import { SearcherModalProductType } from "../../../../../components/common/searchers/searcher-modal/types.js";
const getProduct = (name)=>{
    if (name?.includes('searcher-flight-hotel')) return SearcherModalProductType.SEARCHER_FLIGHT_HOTEL;
    if (name?.includes('searcher-ferry-hotel')) return SearcherModalProductType.SEARCHER_FERRY_HOTEL;
    if (name?.includes('searcher-train-hotel')) return SearcherModalProductType.SEARCHER_TRAIN_HOTEL;
    return name ?? '';
};
const getPrice = (price)=>{
    if (!price) return;
    return {
        ...price,
        from: !!price?.from,
        value: Number(price?.value),
        market_value: price.market_value
    };
};
const getLdJson = (ldjson)=>ldjson && 'scripts' in ldjson ? ldjson : {
        scripts: [
            ldjson
        ]
    };
export const productCardPackagesDesktopConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { title ='' , subtitle ='' , link ={
        href: ''
    } , image ={
        src: ''
    } , config ={} , tag ='' , promotion ='' , rating , tripadvisor , upside =[] , descriptions =[] , price ={} , prices =[] , isDeal =false , ldjson , modal , searcher  } = data;
    const finalPrice = getPrice(prices.length > 0 ? prices[0].price : price);
    const finalLdJson = getLdJson(ldjson);
    const modalData = modal?.data ?? modal?.props ?? {};
    const modalBodyData = modalData.Body?.data ?? modalData.Body?.props ?? {};
    const modalBodySearcher = modalBodyData.searcher?.data ?? modalBodyData.searcher?.props;
    const searcherData = searcher?.data ?? searcher?.props ?? {};
    const product = modal?.name ?? searcher?.name ?? config.type ?? '';
    return {
        ...data,
        config: {
            ...config,
            deal: isDeal || (config.isDeal ?? config.deal),
            hasModal: !!data.modal || !!data.searcher,
            icon: !!config.icon,
            iconName: config.icon,
            rating: config.rating,
            product: getProduct(product),
            soldOut: config.soldOut,
            literals: {
                ...config?.literals,
                fromCaption: data.prices?.[0].price?.from ?? data.price?.from,
                good: config.literals?.good,
                veryGood: config.literals?.veryGood,
                excelent: config.literals?.excelent,
                modalTitle: config.literals?.modalTitle,
                noprice: config.literals?.noPrice,
                perPerson: config.literals?.perPerson,
                summary: config.literals?.summary,
                moreInfo: config.literals?.moreInfo
            }
        },
        title,
        subtitle,
        image,
        link,
        tag,
        rating,
        tripadvisor,
        upside,
        promotion,
        descriptions: descriptions.flatMap((desc)=>desc?.content ?? '') ?? [],
        price: finalPrice,
        offerNote: modal?.data?.Footer?.content,
        expandedInfoPrice: finalPrice,
        searcher: modalBodySearcher ?? searcherData,
        ldjson: finalLdJson
    };
};

//# sourceMappingURL=converter.js.map